import styled from '@emotion/styled';
import React from 'react';
import { Button } from '.';
import { inputSizeStyles } from './Input';

const MenuItemBase = styled(Button)(({ theme, disabled, inputSize = 'default', isActive }) => {
  const { padding, fontSize } = inputSizeStyles[inputSize];

  return ({
    borderRadius: 0,
    textAlign: 'initial',
    backgroundColor: isActive ? theme.rgba(theme.palette.foreground[900][0], .25) : theme.palette.background[500][0],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding,
    ...theme.font.responsiveSize(fontSize),
    '&:hover, &:active, &:focus': !disabled ? {
      boxShadow: 'none',
      backgroundColor: theme.rgba(theme.palette.foreground[900][0], .15),
    } : undefined,
  });
});

const MenuItem = React.forwardRef<HTMLButtonElement, React.ComponentPropsWithoutRef<typeof MenuItemBase>>(
  function MenuItem(props, ref) {
    return (
      <MenuItemBase
        py={1} px={2} tabIndex={0} as="li" variant="flat"
        {...props} ref={ref}
      />
    );
  },
);

export default MenuItem;
